// Copy for the hub's "Upcoming" section (later-upcoming rows + the
// standing-slot subtitle). #1220 established the copy-module convention —
// the row's own date/time stay FORMATTING (asserted directly), not copy.

export const UPCOMING_SECTION_COPY = {
  sectionEyebrow: "Upcoming",
  rescheduleLabel: "Reschedule",
  /** Names the session, so rows are distinguishable to a screen reader. */
  rescheduleAriaLabel: (sessionNumber: number) => `Reschedule session ${sessionNumber}`,
  /** Copy never OPENS with the therapist slot — the "your therapist" fallback
   *  is lowercase and can't start a sentence (G8, see CheckinFlow). Safe here
   *  because "Your standing…" opens with the fixed word, not the slot. */
  standingSlotSubtitle: (weekday: string, therapistName: string) =>
    `Your standing ${weekday} slot with ${therapistName}.`,
} as const;

/** Indexed the way the API sends the weekday — `Mon=0 … Sun=6`, Python's `date.weekday()`,
 *  which is the convention `StandingSlot.weekday` and every scheduling surface already use.
 *  NOT JS's `Date.getDay()` (Sun=0): mixing the two shifts every label by a day, silently. */
const STANDING_SLOT_WEEKDAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
] as const;

/** The weekday's name, or `null` for anything that isn't one of the seven — an unknown day
 *  is one the subtitle must not name, the same reading a missing weekday gets. */
export function standingSlotWeekdayLabel(weekday: number | null): string | null {
  if (weekday === null) return null;
  return STANDING_SLOT_WEEKDAYS[weekday] ?? null;
}
